export enum LangEnum {
  FR = 'fr',
  EN = 'en',
  DE = 'de',
}
